import type {ReactElement} from 'react';
import React, { useState} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {AddAccountIcon} from '@Components/social-media/components/add-account-icon';
import {openSocialAccountConnectionModal} from '@Modals/social-accounts-connection-modal';
import {PANEL_ID} from '@Modals/social-accounts-connection-modal/social-accounts-connection-modal';
import styles from './add-account.module.scss';

interface AddAccountProps {
  onCustomAdd?: VoidFunction;
}

export function AddAccount({onCustomAdd = undefined}: AddAccountProps): ReactElement | null {
  const [isLoadingState, setIsLoadingState] = useState(false);

  const onAddAccount = (): void => {
    setIsLoadingState(true);

    if (onCustomAdd !== undefined) {
      onCustomAdd();
      setIsLoadingState(false);
    } else {
      openSocialAccountConnectionModal({panelId: PANEL_ID});
      setIsLoadingState(false);
    }
  };

  return (
    <ClickableDiv className={`${styles.addAccountContainer} flex-row-align-center _full-width`} onClick={onAddAccount}>
      <AddAccountIcon isLoading={isLoadingState} />
      <span className="spacing-m-l-2 content-body body-xs">{window.i18next.t('pmwjs_add_another_account')}</span>
    </ClickableDiv>
  );
}
